import { useEffect, useRef, useState } from "react";
import { useTV } from "../../../hooks/useTV";

const VipOffStreamBottomBar = ({ onBackClick, timeText }) => {
  const { isTv } = useTV();

  const [focusedButton, setFocusedButton] = useState("back");

  const backButtonRef = useRef(null);

  const buttonStyle = isTv
    ? {
        border: "6px solid white",
        background: "transparent",
        color: "white",
        fontFamily: "Lato",
        fontSize: "55px",
        padding: "0px 20px",
        borderRadius: "20px",
        fontWeight: "700",
        userSelect: "none",
        zIndex: 150,
      }
    : {
        border: "2px solid white",
        background: "transparent",
        color: "white",
        fontFamily: "Lato",
        fontSize: "40px",
        padding: "0px 20px",
        borderRadius: "20px",
        fontWeight: "700",
        userSelect: "none",

        zIndex: 150,
      };

  // Auto-focus logic for TV
  useEffect(() => {
    backButtonRef.current.focus();
    setFocusedButton("back");
  }, [isTv]);

  // Handle keyboard navigation
  useEffect(() => {
    if (isTv) {
      const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleBackClick();
        }
      };

      // Add event listener
      window.addEventListener("keydown", handleKeyDown);

      // Clean up
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTv]);

  // Helper function to get park button styles
  const getParkButtonStyles = (buttonId, baseStyle) => {
    // Only apply focus styles for TV mode
    if (isTv && focusedButton === buttonId) {
      return {
        ...baseStyle,
        color: "white",
        borderColor: "#3ADF3C",
        outline: "none",
        border: "6px solid #3ADF3C",
      };
    }

    return {
      ...baseStyle,
      color: "white",
      borderColor: "#3ADF3C",
      outline: "none",
      border: "6px solid #3ADF3C",
    };
  };

  const handleBackClick = async () => {
    onBackClick();
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "2.2%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100vw",
        zIndex: 110,
        padding: "0 20px",
      }}
    >
      <img
        src="/static/frame-bottom.png"
        alt=""
        style={{
          position: "fixed",
          bottom: "0",
          left: "0",
          width: "100vw",
          zIndex: 100,
        }}
      />

      <span
        style={{
          zIndex: 110,
          fontFamily: "Lato",
          fontSize: isTv ? "50px" : "40px",
          fontWeight: "700",
          color: "white",
          textAlign: "center",
        }}
      >
        Tonight's Magic Kingdom Fireworks: {timeText}
      </span>

      <button
        id="backButton"
        ref={backButtonRef}
        onClick={handleBackClick}
        onContextMenu={(e) => e.preventDefault()}
        onFocus={() => setFocusedButton("back")}
        onBlur={() => setFocusedButton(null)}
        tabIndex={0}
        style={
          isTv
            ? getParkButtonStyles("back", buttonStyle)
            : {
                ...getParkButtonStyles("back", buttonStyle),
                transform: "translateY(5px)", // ↓ nudge non-TV down a bit
              }
        }
      >
        BACK
      </button>
    </div>
  );
};

export default VipOffStreamBottomBar;
